
// Main export file for the armpit cysts article data
import { armpitCystsMetadata } from './metadata';
import { armpitCystsContent } from './content';
import { armpitCystsSources } from './sources';
import { armpitCystsRecommendedProducts } from './recommended-products';
import { armpitCystsRelatedArticles } from './related-articles';

export const armpitCystsArticle = {
  ...armpitCystsMetadata,
  content: armpitCystsContent,
  sources: armpitCystsSources,
  recommendedProducts: armpitCystsRecommendedProducts,
  relatedArticles: armpitCystsRelatedArticles
};
